/* eslint-disable no-const-assign */
/* eslint-disable no-undef */
/* eslint-disable import/extensions */
import config from '~/assets/constants/aws-config.js';

export function getBranding() {
    if (window.location.hostname === 'xlcyberscan.xl.co.id') {
        return 'xl';
    }
    return 'autobahn';
}

export const brandingVars = {
    autobahn: {
        app_name: 'Autobahn Security',
        css_class_navbar: 'navbar-autobahn',
        css_class_navbar_invert: 'navbar-autobahn-inverted',
        css_class_primary_button: 'btn-primary',
        app_icon: '/assets/images/app-icon-32.png',
        app_logo: '/assets/images/Autobahn_horizontal_combination_mark_black.png',
        app_logo_white: '/assets/images/Autobahn_horizontal_combination_mark_white.png',
        card_logo: '/assets/images/SRLabs_logo_blue_on_white.svg',
        mail_support_local: 'support',
        mail_signup_local: 'signup',
        mail_domain: 'autobahn-security.com',
        navtext: ['Autobahn', 'By Security Research Labs'],
        aws_config: config[AB_BUILD],
        aws_config_eu_central: config[`${AB_BUILD}_EU`],
    },
    xl: {
        app_name: 'XL CyberScan',
        css_class_navbar: 'navbar-xl',
        css_class_navbar_invert: 'navbar-xl',
        css_class_primary_button: 'xl-btn-primary',
        app_icon: '/assets/images/logo-xl-2.jpeg',
        app_logo: '/assets/images/nav-logo-xl.png',
        card_logo: '/assets/images/logo-xl-4.png',
        mail_support_local: 'cs-busol',
        mail_signup_local: 'cs-busol',
        mail_domain: 'xl.co.id',
        navtext: ['', ''],
        aws_config: {
            Auth: {
                region: 'us-east-2',
                userPoolId: 'us-east-2_IJOZsFLbr',
                userPoolWebClientId: '6p2ivcdv6i9484m90riff7q5rm',
            },
        },
        // use the same aws config since xl does not need to be migrated
        aws_config_eu_central: {
            Auth: {
                region: 'us-east-2',
                userPoolId: 'us-east-2_IJOZsFLbr',
                userPoolWebClientId: '6p2ivcdv6i9484m90riff7q5rm',
            },
        },
    },
};

export function getBrandingVar(key) {
    const branding = getBranding();
    if (brandingVars[branding][key] === undefined) {
        // fallback to default
        branding = 'autobahn';
    }
    return brandingVars[branding][key];
}

export const brandMixin = {
    methods: {
        brandComponent(el, level) {
            if (getBranding() === 'xl') {
                return `${el}-xl-${level}`;
            }
            return `${el}-${level}`;
        },
        getBrandingVar,
        getBranding,
    },
};
